import React, { memo } from "react";
import s from "styled-components";
import Comment from "_c/Comment";
import { AnimatedList } from "_c/Animated";

const Wrap = s.ul`
  max-height: 500px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 45px;
  }
  ::-webkit-scrollbar {
    width: 5px;
    background-color: transparent;
    border-radius: 45px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(55deg, #a921dd 0%, #e71580 100%);
    border-radius: 45px;
  }
`;
const ReviewComments = ({
  reviewMasterId,
  reviewClientId,
  comments,
  removeComment,
  addComment,
  reviewId,
  authUserId,
  t,
}) => (
  <Wrap>
    <AnimatedList.Container>
      {comments.map((comment) => (
        <AnimatedList.Item key={comment._id} itemKey={comment._id}>
          <Comment
            t={t}
            allowPhoto
            isOwner={comment.author._id === authUserId}
            comment={comment}
            onComment={addComment}
            onRemove={removeComment}
          />
        </AnimatedList.Item>
      ))}
    </AnimatedList.Container>
  </Wrap>
);
ReviewComments.displayName = "ReviewComments";

export default memo(ReviewComments);
